import React, { ReactElement, ReactNode } from 'react';
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@/components/ui/accordion';
import { cn } from '@/lib/utils';

type Props = {
	icon: React.FC<React.SVGProps<SVGSVGElement>> | string;
	label: string;
	value?: string | number | ReactNode;
	content: ReactElement | string;
	componentClassName?: string;
	containerClassName?: string;
	contentClassName?: string;
	triggerIcon?: React.FC<React.SVGProps<SVGSVGElement>>;
	triggerClassName?: string;
	iconClassName?: string;
};

const EPopupAccordion: React.FC<Props> = ({
	icon: Icon,
	label,
	value,
	content,
	componentClassName,
	containerClassName,
	contentClassName,
	triggerIcon,
	triggerClassName,
	iconClassName
}) => (
	<Accordion
		type='single'
		collapsible
		className={cn('w-full', componentClassName)}>
		<AccordionItem
			value='item-1'
			className='w-full'>
			<AccordionTrigger
				icon={triggerIcon}
				iconClassName='size-8 p-1.5 border border-popover-100 rounded-full '
				className={triggerClassName}>
				<div
					className={cn(
						'flex-1 flex items-center gap-2.5 pr-6',
						containerClassName,
					)}>
					{typeof Icon === 'string' ? (
						<img
							src={Icon}
							alt='faq icon'
							className='size-5'
						/>
					) : (
						<div className={cn('stroke-popover-1000', iconClassName)}>
							<Icon className='stroke-inherit fill-inherit' />
						</div>
					)}
						<span className='text-start break-all mr-2.5'>{label}</span>
					{value && <span className='ml-auto mr-5'>{value}</span>}
				</div>
			</AccordionTrigger>
			<AccordionContent className={cn('pr-5.5', contentClassName)}>
				{content}
			</AccordionContent>
		</AccordionItem>
	</Accordion>
);

export default EPopupAccordion;
